import * as a from '../actions/loading'
import { createReducer } from 'redux-act'

let DEFAULT_STATE = {
    isLoading: false,
}

export default createReducer(
    {
        [a.setLoading]: (state, payload) => {
            state.isLoading = payload;
            return { ...state }
        },
    },
    DEFAULT_STATE
);
